(function () {
  'use strict';

  console.log('[bespoke-fee] script loaded');

  const BESPOKE_FEE_PRODUCT_ID = 15609112330588;

  const BESPOKE_VARIANTS = {
    'black':      57772201640284,
    'coffee':     57772201673052,
    'brown':      57772201705820,
    'mocha':      57772201738588,
    'mud':        57772201771356,
    'night blue': 57772201804124,
    'plum':       57772201836892,
    'thyme':      57772201869660,
    'sage':       57772201902428,
    'sky blue':   57772201935196,
    'bordeaux':   57772201967964,
    'nude':       57772202000732,
    'beige':      57772202033500,
    'lime':       57772202066268,
    'matcha':     57772202099036
  };

  const BESPOKE_COLOUR_NAMES = Object.keys(BESPOKE_VARIANTS);
  let isSyncing = false;

  function getBespokeColoursInCart(cart) {
    const colours = new Set();
    const overrides = window.onceMilanoOverrides || {};

    cart.items.forEach(function (item) {
      if (item.product_id === BESPOKE_FEE_PRODUCT_ID) return;

      const productOverrides = (overrides[item.product_id] || []).map(function (o) {
        return o.toLowerCase().trim();
      });

      // — Existing logic: Shopify variant options —
      const colorOption = item.options_with_values
        ? item.options_with_values.find(function (o) {
            return o.name.toLowerCase() === 'color' || o.name.toLowerCase() === 'colour';
          })
        : null;
      if (colorOption) {
        const colour = colorOption.value.toLowerCase().trim();
        if (BESPOKE_COLOUR_NAMES.includes(colour) && !productOverrides.includes(colour)) {
          colours.add(colour);
        }
      }

      // — New logic: Kickflip line item properties (colours in _mczr_attributes) —
      if (item.properties && item.properties['_mczr_attributes']) {
        try {
          const attrs = JSON.parse(item.properties['_mczr_attributes']);
          attrs.forEach(function (attr) {
            const keyLower = (attr.key || '').toLowerCase().trim();
            if (keyLower.includes('rolled hem') || keyLower.includes('scalloped hem')) return;
            if (!keyLower.includes('colour') && !keyLower.includes('color')) return;
            const colour = (attr.value || '').toLowerCase().trim();
            if (!BESPOKE_COLOUR_NAMES.includes(colour)) return;
            if (productOverrides.includes(colour)) return;
            colours.add(colour);
          });
        } catch (e) {
          console.warn('[bespoke-fee] failed to parse _mczr_attributes', e);
        }
      }
    });

    return colours;
  }

  function getFeeItemsInCart(cart) {
    const fees = {};
    cart.items.forEach(function (item) {
      if (item.product_id === BESPOKE_FEE_PRODUCT_ID) {
        fees[item.variant_id] = item.key;
      }
    });
    return fees;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function updateCart(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    return res.json();
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    return res.json();
  }

  async function syncBespokeFees() {
    if (isSyncing) return;
    isSyncing = true;
    console.log('[bespoke-fee] syncing...');
    try {
      const cart = await fetchCart();
      const bespokeColours = getBespokeColoursInCart(cart);
      const feeItems = getFeeItemsInCart(cart);

      const updates = {};
      const toAdd = [];

      Object.entries(feeItems).forEach(function ([variantId, key]) {
        const colour = Object.keys(BESPOKE_VARIANTS).find(
          c => BESPOKE_VARIANTS[c] === parseInt(variantId)
        );
        if (!colour || !bespokeColours.has(colour)) {
          updates[key] = 0;
        }
      });

      bespokeColours.forEach(function (colour) {
        const variantId = BESPOKE_VARIANTS[colour];
        const alreadyInCart = Object.keys(feeItems).some(
          id => parseInt(id) === variantId
        );
        if (!alreadyInCart) {
          toAdd.push({ id: variantId, quantity: 1 });
        }
      });

      let madeChanges = false;
      if (Object.keys(updates).length > 0) {
        await updateCart(updates);
        madeChanges = true;
      }
      if (toAdd.length > 0) {
        await addToCart(toAdd);
        madeChanges = true;
      }
      if (madeChanges && window.location.pathname === '/cart') {
        window.location.reload();
      }

    } catch(e) {
      console.error('[bespoke-fee] error:', e);
    } finally {
      isSyncing = false;
    }
  }

  // Intercept fetch calls to catch cart changes made by the theme
  const originalFetch = window.fetch;
  window.fetch = function(url) {
    const result = originalFetch.apply(this, arguments);
    if (!isSyncing && typeof url === 'string' &&
        (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
      result.then(function() { setTimeout(syncBespokeFees, 500); });
    }
    return result;
  };

  // Run on cart events
  document.addEventListener('cart:updated', syncBespokeFees);
  document.addEventListener('on:cart:add', syncBespokeFees);
  document.addEventListener('on:cart:change', syncBespokeFees);

  // Run on page load
  document.addEventListener('DOMContentLoaded', syncBespokeFees);

})();